import { z } from "zod";

export const FeatureKey = {
  INVITATIONS: "invitations",
  INVITATION_AUTO_INVITE: "invitation.auto_invite",

  PARTICIPANTS_IMPORT_CSV_UPLOAD: "participants.import.csv_upload",

  HOST_EVENTS_CREATE: "host.events.create",

  AGENTS_PORTER: "agents.porter",
  AGENTS_PORTER_RENDERER_DEBUG_DUMP: "agents.porter.renderer_debug_dump",
  AGENTS_PORTER_CUSTOM_FIELDS_CONTEXT: "agents.porter.custom_fields_context",
  AGENTS_PORTER_DIRECTORY_SEARCH: "agents.porter.directory_search",
  AGENTS_PORTER_DIRECTORY_EXPORT: "agents.porter.directory_export",
  AGENTS_PORTER_NOTIFICATIONS: "agents.porter.notifications",

  DIRECTORY_BROWSING: "directory.browsing",
  DIRECTORY_SMART_PREFETCH: "directory.smart_prefetch",
  DIRECTORY_EXPORT: "directory.export",

  AI_RECOMMENDATIONS: "ai.recommendations",

  ENRICHMENT: "enrichment",
  ENRICHMENT_PROCESSOR: "enrichment.processor",
  AUTOMATIC_ENRICHMENT: "enrichment.automatic",

  INTROS: "intros",

  EVENT_THEME: "event.theme",

  EVENT_SUBDOMAIN: "event.subdomain",

  VERIFICATION_CODES: "verification_codes",

  PROFILE_USER_EDIT_LOCKED_FIELDS: "profile.user_edit_locked_fields",
} as const;

export const FeatureKeySchema = z.enum(FeatureKey);

export type FeatureKey = z.infer<typeof FeatureKeySchema>;
